var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageFr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1248,
    height: 1002.667,
    viewBox: "0 0 936 752",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 375.8V752h40.3c22.1 0 71.6-.3 110-.7l69.7-.6V512h237V296H220v-79h310V1h-99.8C375.3 1 256 .7 165.2.3L0-.3v376.1zM920.1 246.1c-28.5 3-52.6 11.9-77.5 28.7-12.8 8.6-18.8 14.1-29.7 27.5-8.9 11-17.6 20.7-18.4 20.7-.3 0-.5-15.8-.5-35v-35.1l-89.5.3c-71.7.2-89.7.6-90.7 1.6-1.1 1.1-1.4 47.4-1.6 248.7l-.4 247.5h182l.5-116.8c.4-115.5.4-116.8 2.6-126.5 4.7-21.1 11.7-34.6 23.4-45.2 19.1-17.4 40.2-23 90.7-24.4l24.5-.6.3-96.3.2-96.2-3.7.1c-2.1.1-7.6.6-12.2 1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageFr);
export default __webpack_public_path__ + "static/media/language-fr.23931494ca647373ecbe706d446e424b.svg";
export { ForwardRef as ReactComponent };